// extracted by mini-css-extract-plugin
export default {"Card":"style_Card__RDtPQ","name":"style_name__AkdVl","position":"style_position__me5KI","inner":"style_inner__MUV89","outer":"style_outer__zKEIk"};